import { FC, useState } from "react";
import { Box } from "../../../../../components/box";
import { Table } from "antd";
import { eContentFields } from "../constant/field-names";

export const ExportList: FC<{
  eRequests: any;
  setERequests: any;
  hiddenEdit?: boolean;
}> = ({ eRequests, setERequests, hiddenEdit }) => {
  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: any, record: any, index: number) => (
        <>{(currentPage - 1) * pageSize + index + 1}</>
      ),
    },
    ...eContentFields.map((value, index) => {
      return {
        title: value.label,
        dataIndex: value.field,
        key: value.field,
      };
    }),
  ];

  const pageSize = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <Box title="Chi tiết">
      <div style={{ overflowX: "scroll" }}>
        <Table
          columns={columns}
          dataSource={eRequests}
          pagination={{
            onChange: (page) => {
              setCurrentPage(page);
            },
            current: currentPage,
          }}
        />
      </div>
    </Box>
  );
};
